import { useRef, useImperativeHandle } from 'react';
// This hooks gives a fallback for the forwarded ref. This way ref value
// can be accessed in the component with forwarded ref no matter if it
// was passed or not. It is essentially a `const ref = forwardedRef && useRef()`,
// if such code did not violate rules of hooks.
export var useFallbackRef = function (ref) {
    var fallbackRef = useRef(null);
    useImperativeHandle(ref, function () { return fallbackRef.current; });
    return fallbackRef;
};
//# sourceMappingURL=index.js.map